'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = undefined;

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _winresCloudService = require('./winresCloudService');

var _customerService = require('./customerService');

var _productService = require('./productService');

var _destinationService = require('./destinationService');

var _ownerService = require('./ownerService');

var _groupReservationService = require('./groupReservationService');

var _reservationService = require('./reservationService');

var _reportService = require('./reportService');

var _departureService = require('./departureService');

var _internetClassificationService = require('./internetClassificationService');

var _exportService = require('./exportService');

var _websiteService = require('./websiteService');

var _busService = require('./busService');

var _omalomaService = require('./omalomaService');

var _messageService = require('./messageService');

var _scheduleService = require('./scheduleService');

var _cancelService = require('./cancelService');

var _analyticsService = require('./analyticsService');

var _filebankService = require('./filebankService');

var _regionService = require('./regionService');

var _discountService = require('./discountService');

var _urlService = require('./urlService');

var _paramService = require('./paramService');

var _agentService = require('./agentService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = exports.name = _module3.default.name;

// Base service for low-level access to the cloud:

_module3.default.service('winresCloudService', _winresCloudService.WinresCloudService);

// Wrapper services for specific requests:

_module3.default.service('customerService', _customerService.CustomerService);

_module3.default.service('productService', _productService.ProductService);

_module3.default.service('destinationService', _destinationService.DestinationService);

_module3.default.service('ownerService', _ownerService.OwnerService);

_module3.default.service('groupReservationService', _groupReservationService.GroupReservationService);

_module3.default.service('reservationService', _reservationService.ReservationService);

_module3.default.service('reportService', _reportService.ReportService);

_module3.default.service('departureService', _departureService.DepartureService);

_module3.default.service('internetClassificationService', _internetClassificationService.InternetClassificationService);

_module3.default.service('exportService', _exportService.ExportService);

_module3.default.service('websiteService', _websiteService.WebsiteService);

_module3.default.service('busService', _busService.BusService);

// Service for handling an Omaloma customer session and caching.

_module3.default.service('omalomaService', _omalomaService.OmalomaService);

// Service for various custom messages intended for users (e.g. legal disclaimers)

_module3.default.service('messageService', _messageService.MessageService);

// Service for activity schedules

_module3.default.service('scheduleService', _scheduleService.ScheduleService);

// Service for canceling promises

_module3.default.service('cancelService', _cancelService.CancelService);

// Google analytics service

_module3.default.service('analyticsService', _analyticsService.AnalyticsService);

_module3.default.service('filebankService', _filebankService.FilebankService);

_module3.default.service('regionService', _regionService.RegionService);

_module3.default.service('discountService', _discountService.DiscountService);

_module3.default.service('urlService', _urlService.UrlService);

_module3.default.service('paramService', _paramService.ParamService);

_module3.default.service('agentService', _agentService.AgentService);


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/index.js
// module id = 553
// module chunks = 2